import { render } from "./Console.vue?vue&type=template&id=70329e16&scoped=true"
import script from "./Console.vue?vue&type=script&lang=js"
export * from "./Console.vue?vue&type=script&lang=js"

import "./Console.vue?vue&type=style&index=0&id=70329e16&scoped=true&lang=css"

import exportComponent from "/opt/md_star/md_star_client/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70329e16"]])

export default __exports__